import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './header';
import Sidebar from './sidebar';

const Layout = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [isMobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    <Box
      display="flex"
      minHeight="100vh"
      position="relative"
      sx={{ overflowX: 'hidden' }}
    >
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        isMobileSidebarOpen={isMobileSidebarOpen}
        onSidebarClose={() => setMobileSidebarOpen(false)}
      />
      <Box
        display="flex"
        flexDirection="column"
        flexGrow={1}
        zIndex={1}
        width="100%"
        sx={{ overflowX: 'hidden' }}
      >
        <Header
          toggleSidebar={() => setSidebarOpen(!isSidebarOpen)}
          toggleMobileSidebar={() => setMobileSidebarOpen(true)}
        />
        <Box flexGrow={1}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
